import React from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

const ADDRESS = "26 Rue Victor Hugo, 93100 Montreuil";
const PHONE = "01.84.16.20.60";
const PHONE_TEL = "tel:+33184162060";
const MAP_SRC =
  "https://www.google.com/maps?q=26+Rue+Victor+Hugo,+93100+Montreuil&output=embed";

export const MapEmbed = () => (
  <section id="contact" className="py-20 md:py-28 bg-[#F1F5F9]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-10 items-stretch">
        <div>
          <div className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-[#FF5A1F] mb-4">
            Nous trouver
          </div>
          <h2
            className="text-4xl sm:text-5xl font-extrabold tracking-tight text-[#0F172A] mb-6"
            style={{ fontFamily: "'Cabinet Grotesk','Manrope', sans-serif" }}
          >
            Au cœur du 93.
          </h2>
          <p className="text-slate-600 text-base md:text-lg mb-8 leading-relaxed">
            Notre siège, situé à Montreuil, nous permet de rayonner sur l'ensemble du
            département en un temps record. Présents au plus près de vos urgences.
          </p>

          <ul className="space-y-5">
            <li className="flex items-start gap-4">
              <div className="w-11 h-11 rounded-lg bg-[#0F172A] text-[#FF5A1F] flex items-center justify-center shrink-0">
                <MapPin className="w-5 h-5" />
              </div>
              <div>
                <div className="text-xs uppercase tracking-wider text-slate-500 font-bold">Adresse</div>
                <div className="font-bold text-[#0F172A]">{ADDRESS}</div>
              </div>
            </li>
            <li className="flex items-start gap-4">
              <div className="w-11 h-11 rounded-lg bg-[#0F172A] text-[#FF5A1F] flex items-center justify-center shrink-0">
                <Phone className="w-5 h-5" />
              </div>
              <div>
                <div className="text-xs uppercase tracking-wider text-slate-500 font-bold">Téléphone</div>
                <a href={PHONE_TEL} data-testid="contact-call-link" className="font-extrabold text-xl text-[#0F172A] hover:text-[#FF5A1F]">
                  {PHONE}
                </a>
              </div>
            </li>
            <li className="flex items-start gap-4">
              <div className="w-11 h-11 rounded-lg bg-[#0F172A] text-[#FF5A1F] flex items-center justify-center shrink-0">
                <Clock className="w-5 h-5" />
              </div>
              <div>
                <div className="text-xs uppercase tracking-wider text-slate-500 font-bold">Horaires</div>
                <div className="font-bold text-[#0F172A]">24h/24 — 7j/7 — Jours fériés</div>
              </div>
            </li>
            <li className="flex items-start gap-4">
              <div className="w-11 h-11 rounded-lg bg-[#0F172A] text-[#FF5A1F] flex items-center justify-center shrink-0">
                <Mail className="w-5 h-5" />
              </div>
              <div>
                <div className="text-xs uppercase tracking-wider text-slate-500 font-bold">Email</div>
                <div className="font-bold text-[#0F172A]">contact@debouchage-93.fr</div>
              </div>
            </li>
          </ul>
        </div>

        <div className="rounded-3xl overflow-hidden border-4 border-white shadow-xl min-h-[400px]">
          <iframe
            src={MAP_SRC}
            title="Carte Débouchage Canalisation 93"
            data-testid="google-map-iframe"
            width="100%"
            height="100%"
            style={{ border: 0, minHeight: 400 }}
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </div>
  </section>
);

export default MapEmbed;
